'use client'

import { formatDateTimeNormal, formatImageURL, formatPrice, getOrderDeliveryBadge, getOrderPaymentBadge } from "@/utils/util"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"
import { ChevronRight, Package } from "lucide-react"

export default function OrderCard({ order }: { order: any }) {
  const pathname = usePathname()
  const images = order.products?.slice(0, 4).map((p: any) => p.variant?.images?.[0]).filter(Boolean) || []
  const itemCount = order.products?.reduce((acc: number, p: any) => acc + (p.quantity || 1), 0) || 0

  return (
    <a href={navigateUrl(`/order/${order.customId}`, pathname)} className="flex items-center gap-4 p-4 rounded-xl border border-border bg-white hover:bg-muted/50 transition-colors group">
      {images.length > 0 ? (
        <div className="relative shrink-0 w-14 h-14">
          {images.length === 1 ? (
            <img src={formatImageURL(images[0])} alt="" className="w-14 h-14 rounded-lg object-cover" />
          ) : (
            <div className="grid grid-cols-2 gap-0.5 w-14 h-14">
              {images.slice(0, 4).map((img: string, i: number) => (
                <img key={i} src={formatImageURL(img)} alt="" className="w-full h-full rounded object-cover" />
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="shrink-0 w-14 h-14 rounded-lg bg-muted flex items-center justify-center">
          <Package className="w-5 h-5 text-muted-foreground" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-semibold text-foreground">#{order.customId}</span>
          {getOrderDeliveryBadge(order)}
          {getOrderPaymentBadge(order)}
        </div>
        <div className="flex items-center gap-2 mt-1 text-xs text-muted-foreground">
          <span>{formatDateTimeNormal(order.createdAt)}</span>
          {itemCount > 0 && (
            <>
              <span>·</span>
              <span>{itemCount} бараа</span>
            </>
          )}
        </div>
        <div className="text-sm font-medium text-foreground mt-1">{formatPrice(order.amount)}</div>
      </div>
      <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0 group-hover:translate-x-0.5 transition-transform" />
    </a>
  )
}
